import BR from './brazil.svg';
import CO from './colombia.svg';

export const flags = { BR, CO };
export default flags;
